var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 10C20 15.5229 15.5229 20 10 20C4.47715 20 0 15.5229 0 10C0 4.47715 4.47715 0 10 0V10H20Z",
    fill: "#132F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5422 7.00024H13V0.458008C16.1101 1.43483 18.5654 3.89014 19.5422 7.00024Z",
    fill: "#132F44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadDashboard);
export default __webpack_public_path__ + "static/media/breadDashboard.a8db4c1a87b0a417e8c07d4b960707a2.svg";
export { ForwardRef as ReactComponent };